<template>
  <div class='Yxtbiz-sp-project-selector'>
    <div class='Yxtbiz-sp-project-selector__content' v-loading='loading'>
      <div class='Yxtbiz-sp-project-selector__list'>
        <div class='Yxtbiz-sp-project-selector__form'>
          <yxt-button plain size='large' class='project-filter-btn' @click='showMoreFilter = !showMoreFilter'>
            <yxt-svg class='v-mid ml8' width='18px' height='18px' icon-class='common_filter' />
            {{ $t('pc-biz-sp-more-select') }}
            <yxt-svg class='v-mid ml8' width='16px' height='16px' :icon-class='showMoreFilter ? "arrow-up" :"arrow-down"' />
          </yxt-button>
          <yxt-input
            class='Yxtbiz-sp-project-selector__input--search'
            searchable
            :placeholder='$t("pc-biz-sp-input-project-search")'
            :maxlength='200'
            v-model='projectName'
            @search='handleSearch'
          />
        </div>
        <keep-alive>
          <MoreFilter v-if='showMoreFilter' ref='moreFilter' @filter-change='onFilterChange' />
        </keep-alive>
        <yxt-table
          ref='selection'
          :row-key='getRowKey'
          :height='tableHeight'
          :data='list'
          @sort-change='handleSortChange'
          @select='handleSelect'
          @select-all='handleSelectAll'
          :default-sort="{ prop: 'publishTime', order: 'desc' }"
        >
          <yxt-table-column type='selection' :reserve-selection='true' width='32'></yxt-table-column>
          <yxt-table-column prop='projectName' :label='$t("pc-biz-sp-project-name")' width='200' :show-overflow-tooltip='true'></yxt-table-column>
          <yxt-table-column prop='projectStatus' :label='$t("pc-biz-sp-status")' width='120'>
            <template slot-scope='scope'>
              {{ [$t('pc-biz-sp-nopublish'), $t('pc-biz-sp-published'), $t('pc-biz-sp-revoke'), $t('pc-biz-sp-over')][scope.row.projectStatus] }}
            </template>
          </yxt-table-column>
          <yxt-table-column prop='createFullname' :label='$t("pc-biz-sp-creater")' width='120' :show-overflow-tooltip='true'>
            <template slot-scope='scope'>
              <yxtbiz-user-name :name='scope.row.createFullname' />
            </template>
          </yxt-table-column>
          <yxt-table-column prop='publishTime' :label='$t("pc-biz-sp-publishdate")' align='right' width='120' sortable='custom'>
            <template slot-scope='scope'>
              {{ scope.row.publishTime && scope.row.publishTime.substring(0, 10) }}
            </template>
          </yxt-table-column>
        </yxt-table>
        <div class='Yxtbiz-sp-project-selector__page'>
          <span class='Yxtbiz-sp-selectall' @click='handleSelect1000'>{{$t('pc_biz_kng_selectall')}}</span>
          <yxt-pagination
            @current-change='handlePageChange'
            :current-page='pagination.current'
            :page-size='pagination.size'
            simple-total
            layout='total, prev, pager, next'
            :total='pagination.total'
          >
          </yxt-pagination>
        </div>
      </div>
      <div class='Yxtbiz-sp-project-selector__selection'>
        <header>{{ $t('pc-biz-sp-selected') }}({{ selectNum }}/{{ limit }} )</header>
        <ul>
          <li class='empty' v-if='selectNum === 0'>{{ $t('pc-biz-sp-plselect') }}...</li>
          <li v-for='se in selection' :key='se.projectId'>
            <yxt-tag closable type='info' @close='handleRemove(se)'>
              <span>{{ se.projectName }}</span>
            </yxt-tag>
          </li>
        </ul>
        <div class='Yxtbiz-sp-project-selector__clear'>
          <yxt-button type='text' @click='handleClear' :disabled='selectNum <= 0'>{{ $t('pc-biz-sp-clearall') }}</yxt-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { queryProject } from './server';
import MoreFilter from './moreFilter.vue';

export default {
  name: 'YxtbizSparringProjectSelector',
  components: {
    MoreFilter
  },
  props: {
    limit: {
      type: Number,
      default: 1000
    },
    selected: Array,
    navCode: {
      type: String,
      default: ''
    },
    dataPermsCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      visible: false,
      tableHeight: 300,
      list: [],
      selection: this.selected, // 选择的项目
      projectName: '',
      pagination: {
        current: 1,
        size: 50,
        total: 0,
        orderKey: 'publishTime',
        orderSort: 'desc'
      },
      loading: true,
      showMoreFilter: false
    };
  },
  watch: {
    selected: {
      handler(val) {
        this.selection = val;
        this.refreshData();
      },
      immediate: true,
      deep: true
    },
    selection: {
      handler(val) {
        this.$emit('update:selected', val);
      }
    }
  },
  computed: {
    selectNum() {
      return this.selection.length;
    }
  },
  mounted() {
    setTimeout(() => {
      this.onWindowSizeChange();
    }, 300);
    window.addEventListener('resize', this.onWindowSizeChange);
    this.handleOpen();
  },
  methods: {
    // 转换时间
    formatTen(num) {
      return num > 9 ? (num + '') : ('0' + num);
    },
    formatDate(date) {
      if (!date) {
        return;
      }
      var realDate = new Date(date);
      var year = realDate.getFullYear();
      var month = realDate.getMonth() + 1;
      var day = realDate.getDate();
      var hour = realDate.getHours();
      var minute = realDate.getMinutes();
      return year + '-' + this.formatTen(month) + '-' + this.formatTen(day) + ' ' + this.formatTen(hour) + ':' + this.formatTen(minute);
    },
    dateFormat(row) {
      return row.publishTime ? this.formatDate(row.publishTime) : '--';
    },
    /**
     * 监听窗体打开
     */
    handleOpen() {
      this.pagination.current = 1;
      this.pagination.orderKey = '';
      this.pagination.orderSort = '';
      this.projectName = '';
      this.fetchData();
    },
    handleSearch() {
      this.pagination.current = 1;
      this.fetchData();
    },
    fetchData() {
      this.loading = true;
      const params = this.getSearchParams();
      queryProject(params).then(res => {
        this.list = res.datas;
        this.pagination.total = res.paging.count;
        this.refreshData();
      }).finally(() => {
        this.loading = false;
      });
    },
    refreshData() {
      this.list.map(item => {
        let isSelected = this.selection.findIndex(s => s.projectId === item.projectId) >= 0;
        this.$refs.selection.toggleRowSelection(item, isSelected);
      });
    },
    /**
     * 勾选其中一列
     */
    handleSelect(selection, row) {
      let _index = this.checkIsSelectItem(row);
      if (_index < 0) {
        this.selection.push(row);
        return;
      }
      this.selection.splice(_index, 1);
    },

    /**
     * 抽屉内部删除(点击确定后才确认)
     */
    handleRemove(item) {
      if (!item) return;
      let _index = this.checkIsSelectItem(item);
      if (_index < 0) return;
      this.selection.splice(_index, 1);
      this.$refs.selection.toggleRowSelection(item, false);
    },
    /**
     * 判断是否为已选择项目
     */
    checkIsSelectItem(item) {
      if (!item) return -1;
      return this.selection.findIndex(se => se.projectId === item.projectId);
    },
    /**
     * 清除所有选中
     */
    handleClear() {
      this.selection = [];
      this.$refs.selection.clearSelection();
    },
    /**
     * 全选
     */
    handleSelectAll(selection) {
      if (!selection || !Array.isArray(selection)) return;
      if (selection.length <= 0) {
        this.list.map(item => {
          let _index = this.checkIsSelectItem(item);
          if (_index >= 0) {
            this.selection.splice(_index, 1);
          }
        });

        return;
      }
      selection.forEach(item => {
        if (this.checkIsSelectItem(item) < 0) {
          this.selection.push(item);
        }
      });
    },
    /**
     * 点击确定按钮
     */
    handleSure() {
      if (this.selectNum > this.limit) {
        return this.$message.error(this.$t('pc-biz-sp-pjnoover') + this.limit);
      }
      this.visible = false;
    },

    /**
     * 页面改变时触发
     */
    handlePageChange(e) {
      this.pagination.current = e;
      this.fetchData();
    },
    /**
     * 页面变化时监听
     */
    onWindowSizeChange() {
      const clientHeight = document.body.clientHeight;
      const h = clientHeight - 275;
      this.tableHeight = h > 300 ? h : 300;
    },
    getRowKey(row) {
      return row.projectId;
    },
    handleSortChange(e) {
      const { order, prop } = e;
      if (order) {
        this.pagination.orderKey = prop;
        this.pagination.orderSort = order;
      } else {
        this.pagination.orderKey = '';
        this.pagination.orderSort = '';
      }
      this.fetchData();
    },
    reset() {
      this.selection = [];
      this.$refs.selection && this.$refs.selection.clearSelection();
    },
    onFilterChange() {
      this.pagination.current = 1;
      this.fetchData();
    },
    getSearchParams(data) {
      this.$refs.selection && this.$refs.selection.clearSelection();
      let params = { ...this.pagination };
      if (this.projectName) {
        params.projectName = this.projectName;
      }
      const filterParams = this.$refs.moreFilter && this.$refs.moreFilter.searchParams;
      return {
        navCode: this.navCode,
        dataPermsCode: this.dataPermsCode,
        ...params,
        ...filterParams,
        ...data
      };
    },
    async handleSelect1000() {
      if (!this.pagination.total) {
        return;
      }
      this.pagination.current = 1;
      this.loading = true;
      try {
        const max = 5000;
        let list = [];
        if (this.limit <= max) {
          const params = this.getSearchParams({
            size: this.limit
          });
          list = (await queryProject(params)).datas;
        } else {
          const n = Math.ceil(this.pagination.total / max);
          for (let i = 0; i < n; i++) {
            const params = this.getSearchParams({
              size: max,
              current: i + 1
            });
            list.push(...(await queryProject(params)).datas);
          }
        }
        this.selection = list;
        this.refreshData();
      } catch (e) {}
      this.loading = false;
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.onWindowSizeChange);
  }
};
</script>
<style lang='scss'>
.Yxtbiz-sp-project-selector {
  box-sizing: border-box;
  width: 100%;
  height: 100%;

  &__input {
    width: 292px;

    &--search {
      width: 240px;
      margin-right: 24px;
    }
  }

  &__content {
    display: flex;
    width: 100%;
    height: 100%;
  }

  &__list {
    flex: 1;
    padding: 0 20px 0 0;
    overflow-y: auto;
  }

  &__selection {
    position: relative;
    box-sizing: border-box;
    width: 260px;
    padding: 0 0 0 20px;
    border-left: 1px solid #ededed;

    .red {
      color: red;
      font-weight: bold;
    }

    & > header {
      position: relative;
      margin-bottom: 8px;
      color: #262626;
      font-weight: 400;
      font-size: 14px;

      .clear {
        position: absolute;
        top: 3px;
        right: 0;
        color: #2196f3;
        font-size: 12px;
      }
    }

    & > ul {
      height: calc(100% - 50px);
      overflow-y: auto;

      & > li {
        margin-bottom: 8px;

        &.empty {
          color: #bfbfbf;
          font-weight: 400;
          font-size: 14px;
          line-height: 22px;
        }

        .yxt-tag {
          max-width: 100%;

          & > span {
            width: 100%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }

  &__clear {
    position: absolute;
    bottom: 0;
    left: 24px;
  }

  &__form {
    box-sizing: border-box;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
  }

  &__page {
    padding: 16px 0 0;
    text-align: right;
    position: relative;
  }

  .project-filter-btn {
    margin-right: 50px;

    > span {
      display: flex;
      align-items: center;
    }
  }
}

.Yxtbiz-sp-selectall {
  position: absolute;
  left: 16px;
  top: 20px;
  color: var(--color-primary-6);
  cursor: pointer;
}

</style>
